/** The longest name the calls service takes for a guest. */
export const GUEST_NAME_MAX = 80;

// Control characters, and the bidirectional overrides that let a name draw
// itself backwards over the text beside it.
const UNSAFE = /[\p{Cc}\u200e\u200f\u202a-\u202e\u2066-\u2069]/gu;

/**
 * A guest picks their own name and the service checks only its length, so
 * every place that draws one passes it through here first. The result is plain
 * text for a text node, never markup, and never empty.
 */
export function guestDisplayName(raw: string | null | undefined, fallback = 'A guest'): string {
  const clean = (raw ?? '').replace(/\s+/g, ' ').replace(UNSAFE, '').trim();
  return clean.slice(0, GUEST_NAME_MAX).trim() || fallback;
}
